import React, { useEffect } from 'react'
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom'
// import Comming from './Comming'
import Home from './Home'
import Services from './Services'
import Blog from './Blog'
import Career from './Career'
import Contact from './Contact'
import Aboutus from './Aboutus'
// import Product from './Product'
import ClientProjects from './ClientProjects'

const Routercontaner = () => {
  const ScrollToTop = () => {
    const location = useLocation();
    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);

    return null;
  };
  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='' element={<Home />} />
          <Route path='/*' element={< Home />} />
          <Route path='/home' element={<Home />} />
          <Route path='/About-us' element={<Aboutus />} />
          <Route path='/Services' element={<Services />} />
          <Route path='/Blog' element={<Blog />} />
          <Route path="/projects" element={<ClientProjects />} />
          <Route path='/Career' element={<Career />} />
          <Route path='/Contact' element={<Contact />} />
          {/* <Route path='/Product' element={<Product />} /> */}
        </Routes>
      </BrowserRouter>
    </>
  )
}

export default Routercontaner